import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loader from "components/Loader";

// const YearMonthFilters = lazy(() =>
//   import("pages/FiltersSidebar/YearMonthFilters")
// );



const MTPPublicInvestmentPlanFilters = lazy(() => import("pages/MTPPublicInvestmentPlan/filters"));
const InvestmentStreamsFilters = lazy(() => import("pages/InvestmentStreams/filters"));
const StateSectoralPipelinesFilters = lazy(() => import("pages/StateSectoralPipelines/filters"));
const StateSingleProjectPipelineFilters = lazy(() => import("pages/StateSingleProjectPipeline/filters"));
const ExpertEvaluationOfProjectsAndProgramsFilters = lazy(() => import("pages/ExpertEvaluationOfProjectsAndPrograms/filters"));
const PublicInvestmentProjectDetailsFilters = lazy(() => import("pages/PublicInvestmentProjectDetails/filters"));
const ProgramDetailsFilters = lazy(() => import("pages/ProgramDetails/filters"));
const SectoralEvaluationFilters = lazy(() => import("pages/SectoralEvaluation/filters"));

const MTPPublicInvestmentPlanFiltersPopups = lazy(() => import("pages/MTPPublicInvestmentPlan/filterspopups"));
const InvestmentStreamsFiltersPopups = lazy(() => import("pages/InvestmentStreams/filterspopups"));
const SectoralEvaluationFiltersPopups = lazy(() => import("pages/SectoralEvaluation/filterspopups"));

export default function SideBar() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="p-2">

      <Switch>
          <Route exact path="/mtp">
            <MTPPublicInvestmentPlanFiltersPopups />
          </Route>
          <Route path="/investmentStreams">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* InvestmentStreamsFiltersPopups */}
          </Route>
          <Route path="/sp">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/spp">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/expertEvaluation">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/pipDetails">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/programDetails">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* StateSectoralPipelinesFiltersPopups */}
          </Route>
          <Route path="/sectoralEvaluation">
            <MTPPublicInvestmentPlanFiltersPopups /> {/* SectoralEvaluationFiltersPopups */}
          </Route>
        </Switch>    

        {/* <YearMonthFilters /> */}
        
        <Switch>
          <Route exact path="/mtp">
            <MTPPublicInvestmentPlanFilters />
          </Route>
          <Route path="/investmentStreams">
            <InvestmentStreamsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/sp">
            <StateSectoralPipelinesFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/spp">
            <StateSingleProjectPipelineFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/expertEvaluation">
            <ExpertEvaluationOfProjectsAndProgramsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/pipDetails">
            <PublicInvestmentProjectDetailsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/programDetails">
            <ProgramDetailsFilters /> {/* InvestmentStreamsFilters */}
          </Route>
          <Route path="/sectoralEvaluation">
            <SectoralEvaluationFilters /> {/* InvestmentStreamsFilters */}
          </Route>
        </Switch>

      </div>
    </Suspense>
  );
}
